import { ExternalLink } from 'lucide-react'
import { Link } from 'react-router-dom'

import { runPageHref } from '../../lib/component-links'
import { useIsGlobalAdmin } from '../../lib/global-admin'
import { Button } from '../ui/button'

export function OpenRunLink({ runId }: { runId: string }) {
  const canOpenRun = useIsGlobalAdmin()
  if (!canOpenRun) return null
  return (
    <Button variant="ghost" size="xs" asChild>
      <Link to={runPageHref('custom', runId)}>
        Open run
        <ExternalLink className="size-3" />
      </Link>
    </Button>
  )
}

/** Durable action for a completed background run on its settled chat turn. */
export function CompletedCustomAgentRunLinks({ runId }: { runId: string }) {
  return (
    <div className="flex justify-end gap-1.5 empty:hidden">
      <OpenRunLink runId={runId} />
    </div>
  )
}
